import { Button } from "antd";
import React, { useState, useEffect, memo } from "react";
import { Else, If, Then } from "react-if";
import InfiniteScroll from "react-infinite-scroller";
import { nextgenWelcomeIcon, SendIcon } from "../../../../assets/svg";
import ConfirmPopup from "../../../../components/confirmPopup";
import LoadingSpinner from "../../../../components/loadingSpinner";
import ChatHeader from "../chatHeader/chatHeader";
import welcomeChatIcon from "../../../../images/chat/welcome.png";
import "./chat.scss";
import { NEXTGEN_EHR_WHITELABEL } from "../../../../constants/constants";

const ChatInner = (props) => {
  const {
    loadMore,
    displayChat,
    handleSubmit,
    textInputRef,
    handleChange,
    sendMessageRef,
    claimChat,
    handleCancel,
    handleChatInput,
    handleClaimButton,
    chatProps,
    chatState,
  } = props;

  const { handleShowDetails, user, patients, handleAgentChat } = chatProps;

  const { claimChatPopup, allowTyping, hasMore, value } = chatState;

  const [typing, setTyping] = useState(false);

  useEffect(
    () => {
      const delayDebounceFn = setTimeout(() => {
        if (localStorage.getItem("tabSetAgent") === "activeChat") {
          props.sendAgentTypingMessage();
          setTyping(false);
        }
      }, 2000);
      return () => clearTimeout(delayDebounceFn);
    },
    [typing]
  );

  const tabSet = localStorage.getItem("tabSetAgent");

  const getLabelBasedOnTab = (tab) => {
    const label = tab === "unClaimedChat" ? "Claim" : "Open";
    return label;
  };

  return (
    <>
      <If condition={claimChatPopup}>
        <Then>
          <ConfirmPopup
            titleMessage="Confirm to Open"
            handleCancel={handleCancel}
            handleDelete={() => {
              claimChat({
                patientId: patients.patient.id,
              });
            }}
            isVisible={claimChatPopup}
            submitButtonText="Open"
            cancelButtonText="Cancel"
            message="Are you sure you want to open this chat for communication?"
          />
        </Then>
      </If>

      <div className="chat-main-content">
        <If condition={patients.patient}>
          <Then>
            <>
              <ChatHeader
                handleShowDetails={handleShowDetails}
                handleAgentChat={handleAgentChat}
              />

              <div className="chat-messages-container">
                <InfiniteScroll
                  pageStart={0}
                  loadMore={loadMore}
                  hasMore={hasMore}
                  loader={
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background-transparent"
                    />
                  }
                  isReverse={true}
                  threshold={50}
                  initialLoad={true}
                  useWindow={false}
                >
                  <div
                    className="messages-container"
                    id="messages"
                    ref={(node) => {
                      // eslint-disable-next-line no-self-assign
                      node = node;
                    }}
                  >
                    {displayChat()}
                  </div>
                </InfiniteScroll>
              </div>
              <If
                condition={patients.patient && user && tabSet === "activeChat"}
              >
                <Then>
                  <If condition={user && user.liveChatEnabled}>
                    <Then>
                      <div className="send-message-container">
                        <form onSubmit={handleSubmit}>
                          <section className="input-with-link-wrapper">
                            <input
                              className="chat-input"
                              type="text"
                              ref={textInputRef}
                              value={value}
                              onChange={handleChange}
                              onKeyDown={(e) => {
                                setTyping(true);
                                if (e.key === 13) {
                                  handleChatInput(e);
                                }
                              }}
                              disabled={
                                !allowTyping || (user && user.liveChatEnabled)
                                  ? false
                                  : true
                              }
                              placeholder="Type a message …"
                            />
                          </section>

                          <section className={`input-buttons-container`}>
                            <Button
                              type="text"
                              className="chatInputSubmit"
                              onClick={handleSubmit}
                              disabled={
                                user &&
                                user.liveChatEnabled &&
                                !sendMessageRef.current
                                  ? false
                                  : true
                              }
                            >
                              <SendIcon />
                            </Button>
                          </section>
                        </form>
                      </div>
                    </Then>

                    <Else>
                      <div className="limited-user-message">
                        No number has been alloted. You won't be able to send or
                        receive messages. <strong>Please contact admin</strong>
                      </div>
                    </Else>
                  </If>
                </Then>
              </If>

              <If condition={tabSet && tabSet !== "activeChat"}>
                <Then>
                  <div className="claim-panel">
                    <span className="claim-message">
                      <button
                        className="claim-button"
                        onClick={handleClaimButton}
                      >
                        {getLabelBasedOnTab(tabSet)}
                      </button>{" "}
                      this chat to communicate with this person
                    </span>
                  </div>
                </Then>
              </If>
            </>
          </Then>

          <Else>
            <div className="chat-welcome-message">
              {NEXTGEN_EHR_WHITELABEL ? (
                nextgenWelcomeIcon
              ) : (
                <img src={welcomeChatIcon} alt="" />
              )}
              <section className="content">
                <p className="heading">Nothing to show</p>

                <p className="message">
                  Please select active chats from the left panel and start
                  conversing.
                </p>
              </section>
            </div>
          </Else>
        </If>
      </div>
    </>
  );
};

export default memo(ChatInner);
